<template>
  <div class="admin flex-wrap" :class="{ 'menu-open': menuOpen }">
    <div
      v-if="$route.meta.activeMenu != 'instruction'"
      class="mobile-menu-toggle"
      @click="menuOpen = !menuOpen"
    >
      <i class="el-icon-s-unfold" />
    </div>
    <div class="mobile-menu-mask" @click="menuOpen = false" />
    <el-container>
      <el-aside v-if="$route.meta.activeMenu != 'instruction'" width="200px">
        <Sidebar />
      </el-aside>
      <el-main>
        <Header />
        <div
          class="main"
          :class="{ blue: $route.meta.activeMenu != 'instruction' }"
        >
          <router-view />
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import Sidebar from '@/components/toolbar/Sidebar.vue'
import Header from '@/components/toolbar/Header.vue'
export default {
  name: 'Admin',
  components: {
    Sidebar,
    Header
  },
  data() {
    return {
      menuOpen: false
    }
  },
  watch: {
    // 移动端点击菜单跳转后自动收起侧边栏
    $route() {
      this.menuOpen = false
    }
  },
  mounted() {
    this.checkLogin()
  },
  methods: {
    async checkLogin() {
      const ret = await this.$http.checkLogin()
      const me = this
      if (ret.code == 200) {
        localStorage.setItem('userInfo', JSON.stringify(ret.data.info))
      } else {
        me.$router.push('/login')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.admin {
  height: 100%;
  .el-main {
    padding: 0 !important;
    .main {
      padding: 0 40px 40px;
      min-height: 100%;
      box-sizing: border-box;
      &.blue {
        background-color: #5b74ab;
      }
    }
  }
}
</style>
